import { createVNode as a, mergeProps as d } from "vue";
import l from "../node_modules/@pf-ui/pf-icon-svg/es/asn/LogoutFilledStandard.js";
import i from "../components/PfIcon.js";
const t = (o, r) => {
  const e = {
    ...o,
    ...r.attrs
  };
  return a(i, d(e, {
    icon: l
  }), null);
};
t.displayName = "LogoutFilledStandard";
t.inheritAttrs = !1;
export {
  t as default
};
